import styled from "styled-components";
import Typography from "@mui/material/Typography";

export const Title = styled(Typography).attrs({
  variant: "body2",
  color: "text.secondary",
  align: "center",
  sx: { mt: 5 },
})``;
